import { gql, graphQueryBang } from "shared/lib/graphql"
import { topPublishedAppletsMapper } from "./gql_data_mapper"

const metricsData = `
  metrics {
    new_users_TIME_PERIOD
    top_published_applets_TIME_PERIOD {
      user_count
      normalized_applet {
        id
        icon_url
        service_name
        service_slug
        name
        author
        by_service_owner
        brand_color
        installs_count
        config_type
        pro_features
        intermediate_pro_features
        permissions {
          id
          icon_url
          channel {
            module_name
          }
        }
      }
    }
  }
`

const topPublishedAppletsQuery = gql`
  query(
    $service: String!
    $current_metric_date: DataServiceDate!
    $category_name: String,
    $works_with_channel_name: String
  ) {
    service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
      category_name: $category_name
      works_with_channel_module_name: $works_with_channel_name
    ) {
      ${metricsData}
    }
  }
`

export const worksWithTopPublishedAppletsQuery = gql`
  query(
    $service: String!
    $current_metric_date: DataServiceDate!
    $category_name: String,
    $works_with_channel_name: String
  ) {
    service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
      category_name: $category_name
      works_with_channel_module_name: $works_with_channel_name
    ) {
      works_with_metrics {
        ${metricsData}
      }
    }
  }
`

export const categoryTopPublishedAppletsQuery = gql`
  query(
    $service: String!
    $current_metric_date: DataServiceDate!
    $category_name: String,
    $works_with_channel: String
  ) {
    service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
      category_name: $category_name
      works_with_channel_module_name: $works_with_channel
    ) {
      category_metrics {
        ${metricsData}
      }
    }
  }
`

const composedQuery = (query, timePeriodMetric) =>
  query.replace(/TIME_PERIOD/g, timePeriodMetric)

export default function topPublishedAppletsFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  { currentMetricDate, timePeriodInDays, timePeriodMetric },
  mapper = topPublishedAppletsMapper,
  query = topPublishedAppletsQuery
) {
  return graphQueryBang(composedQuery(query, timePeriodMetric), {
    service: serviceModuleName,
    current_metric_date: currentMetricDate,
    category_name: categoryName,
    works_with_channel_name: worksWithChannelName,
  }).then(data => mapper(data, timePeriodInDays, timePeriodMetric))
}
